/**
 * @name setSmoothScroll.js
 */

class setSmoothScroll {
    constructor() {
        this.flag = document.querySelectorAll('[data-anchor]');
        if (!this.flag) return;

        this.links = this.flag;
        this.toTopBtn = document.querySelector('.toTopButton');

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.__event();
    }

    /**
     * @name __event
     */
    __event() {
        this.links.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                this.__smoothScroll(link.getAttribute("href"));
            });
        });

        if (this.toTopBtn) {
            this.toTopBtn.addEventListener("click", () => this.__smoothScroll(null));
        }
    }

    /**
     * @name __smoothScroll
     * @param {*} hash 
     */
    __smoothScroll(hash) {
        let header = document.querySelector('.header');
        let targetId = hash ? hash.substring(hash.indexOf("#")) : null;
        let targetOffsetTop = !targetId ? 0 : window.pageYOffset + document.querySelector(targetId).getBoundingClientRect().top - header.clientHeight;
        window.scrollTo({
            top: targetOffsetTop,
            behavior: "smooth",
        });
    }
}

export default setSmoothScroll;